import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { Box } from '@material-ui/core'

import PreRegistrationsTableRow from '../PreRegistrationsTableRow'
import PerfectScrollbar from 'react-perfect-scrollbar'

import PropTypes from 'prop-types'

const PreRegistrationsTable = ({ preRegistrations, refresh }) => {
  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: true, useBothWheelAxes: true }}
      >
        <Table emptyMessage="Nenhum segmento e preço encontrado" noWrap>
          <TableHead>
            <TableRow>
              <TableCell width="5%">ID</TableCell>
              <TableCell width="25%" align="left">
                Nome
              </TableCell>
              <TableCell width="20%" align="left">
                CNPJ/CPF
              </TableCell>
              <TableCell width="15%" align="left">
                Origem
              </TableCell>
              <TableCell width="15%" align="left">
                Status
              </TableCell>
              <TableCell width="15%" align="left">
                Data de criação
              </TableCell>
              <TableCell width="5%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {preRegistrations.map((preRegistration) => (
              <PreRegistrationsTableRow
                preRegistration={preRegistration}
                key={preRegistration.id}
                refresh={refresh}
              />
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

PreRegistrationsTable.propTypes = {
  preRegistrations: PropTypes.arrayOf(Object),
}

export default PreRegistrationsTable
